import { AssetHistoryItem, TransactionType } from '@shared/api';

export const isTransfer = (transaction: AssetHistoryItem) =>
  [TransactionType.Deposit, TransactionType.Withdrawal].includes(transaction.type);
